module.exports = __webpack_public_path__ + "static/media/what-the-help-cover.e21a68bd.png";